import { RootState } from '../../store/rootReducer';

export const PrivacyPolicyContentSelector = (state: RootState) => state.content.privacyPolicy;
